import { Device } from "callable-data-objects";
import FlowWidget from "Components/Device/Flow/FlowWidget";
import {
  ConnectMapping,
  ConnectMappingDevice,
  LinkType,
  NodeInputOutput,
  NodeType,
} from "Components/Device/Flow/types";

export const getOutputs = (device: Device): NodeInputOutput[] => {
  const arr: NodeInputOutput[] = [];
  device.connects.forEach((c: ConnectMapping) => {
    if (["HANGUP", "BUSY", "TEMP_UNAVAILABLE"].indexOf(c.connect) === -1)
      arr.push({ id: `${c.type}-${device.id}`, alignment: "right" });
  });
  return arr;
};

export const getSchema = (
  devices: Device[] | undefined,
  device: Device | undefined
): any => {
  if (!devices || !device) return { nodes: [], links: [] };
  const schema = getNodeIds(devices, new Device(device), [], [], 20, 60);
  let x = 0;

  const remapped = schema.nodes.map((node: NodeType) => {
    if (x !== 0 && node.coordinates[0] === x) {
      node.coordinates = [x, node.coordinates[1] + 100];
    }
    x = node.coordinates[0];
    return node;
  });
  return { nodes: remapped, links: schema.links };
};

const getNodeIds = (
  devices: Device[],
  device: Device,
  nodes: NodeType[],
  links: LinkType[],
  x: number,
  y: number
): any => {
  if (x > window.innerWidth - 240) {
    x = 20;
    y = y + 150;
  }

  if (device && !nodes.find((n) => n.id === device.id)) {
    addNode(nodes, device, x, y);

    device.connects
      .map((c) => getMappedDevice(c, devices))
      .forEach((c) => {
        if (c) {
          addLink(links, c, device);
          getNodeIds(devices, new Device(c.md), nodes, links, x + 340, y);
        }
      });
  }
  return { nodes, links };
};

const addLink = (
  links: LinkType[],
  c: ConnectMappingDevice,
  device: Device
) => {
  links.push({
    output: `device-${c.md.id}`,
    input: `${c.cd.type}-${device.id}`,
    label: c.cd.type,
    readonly: true,
  });
};

const addNode = (nodes: NodeType[], device: Device, x: number, y: number) => {
  const node = {
    id: device.id,
    render: FlowWidget,
    coordinates: [x, y],
    outputs: getOutputs(device),
    inputs: [{ id: `device-${device.id}`, alignment: "left" }],
    data: { device },
  };
  nodes.push(node);
};

const getMappedDevice = (
  c: ConnectMapping,
  devices: Device[]
): ConnectMappingDevice | undefined => {
  const mappedDevice: Device | undefined = devices.find(
    (d) => d.id === c.connect
  );
  if (mappedDevice) return { md: mappedDevice, cd: c };
};

export const maxNodePosistion = (schema: any): number => {
  return Math.max.apply(
    Math,
    schema.nodes.map((o: NodeType) => {
      return o.coordinates[1];
    })
  );
};
